import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/rate/style";
import _Rate from "antd/es/rate";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';

/**
 * 评分组件
 *
 * @param
 */
var FieldRate = function FieldRate(_ref, ref) {
  var text = _ref.text,
      mode = _ref.mode,
      render = _ref.render,
      renderFormItem = _ref.renderFormItem,
      fieldProps = _ref.fieldProps;

  if (mode === 'read') {
    var dom = /*#__PURE__*/React.createElement(_Rate, _extends({
      allowHalf: true,
      disabled: true,
      ref: ref
    }, fieldProps, {
      value: text
    }));

    if (render) {
      return render(text, _objectSpread({
        mode: mode
      }, fieldProps), /*#__PURE__*/React.createElement(React.Fragment, null, dom));
    }

    return dom;
  }

  if (mode === 'edit' || mode === 'update') {
    var _dom = /*#__PURE__*/React.createElement(_Rate, _extends({
      allowHalf: true,
      ref: ref
    }, fieldProps));

    if (renderFormItem) {
      return renderFormItem(text, _objectSpread({
        mode: mode
      }, fieldProps), _dom);
    }

    return _dom;
  }

  return null;
};

export default /*#__PURE__*/React.forwardRef(FieldRate);